<template>
  <div class="full-container">
    <div
        style="width: 100%;float: left;height: 50px;line-height: 50px;font-size: 0.9rem; text-align: left;opacity: 0.9;">
      订单>提现结算
    </div>
    <div style="width:100%;height:auto;float:left;border-radius: 15px;background-color: white;padding-bottom:40px;">

      <div style="width:100%;float:left;margin-top: 10px;">
        <!-- 查询按钮区 -->
        <div style="width: 100%;height: 60px;float: left;line-height: 60px;padding-left: 15px">

          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">是否结算：</label>
            <el-select v-model="selectForm.isSettlement" clearable filterable size="mini" style="width:100px;float: left;">
              <el-option v-for="item in alexBoolList" :key="item.value" :label="item.zhName" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">订单号：</label>
              <el-input v-model="selectForm.orderNo" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                        size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px;text-align: left;">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">商户：</label>
            <el-select v-model="selectForm.merchantId" clearable filterable size="mini" style="float: left;">
              <el-option v-for="item in merchantList" :key="item.id" :label="item.merchantDetailVO.companyName" :value="item.id">
              </el-option>
            </el-select>
          </div>

          <div style="width: auto;float: left;margin-right: 20px">
            <el-button size="mini" style="background-color: #25AD7F;border:none;" type="primary"
                       @click="pageOrderSettlement(true)">搜索
            </el-button>
            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="selectReset()">重置
            </el-button>
          </div>
          <!-- 右边按钮 -->
          <div style="width: auto;float: right;margin-right: 20px">


            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="exportTable">
              <a-icon type="plus-circle"/>
              批量导出
            </el-button>

          </div>


        </div>

        <!-- 表单内容 -->
        <div style="width:100%;float:left;padding: 15px;">
          <el-table v-loading="tableLoading" :data="tableData" align="center" height="600" size="mini"
                    style="color: #555;" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="订单号" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.orderVO ? scope.row.orderVO.orderNo : "" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="商户" min-width="20%">
              <template slot-scope="scope">
                {{
                  scope.row.orderVO && scope.row.orderVO.merchantVO && scope.row.orderVO.merchantVO.merchantDetailVO ? scope.row.orderVO.merchantVO.merchantDetailVO.companyName : ""
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="产品名称" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.orderVO.productVO ? scope.row.orderVO.productVO.name : "" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="产品金额" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.orderVO ? scope.row.orderVO.productMoney : "" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="支付金额" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.orderVO ? scope.row.orderVO.payMoney : "" }}
              </template>
            </el-table-column>

            <el-table-column align="center" label="提现手续费" min-width="20%">
              <template slot-scope="scope">
                0.6%
              </template>
            </el-table-column>
            <el-table-column align="center" label="提现金额" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.orderVO ? mexFeixd(scope.row.orderVO.payMoney * (1 - 0.0006)) : "" }}
              </template>
            </el-table-column>


            <el-table-column align="center" label="账户名称" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.orderVO.merchantVO.merchantPublicAccountVO ? scope.row.orderVO.merchantVO.merchantPublicAccountVO.name : ""  }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="开户银行" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.orderVO.merchantVO.merchantPublicAccountVO ? scope.row.orderVO.merchantVO.merchantPublicAccountVO.bank : "" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="开户支行" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.orderVO.merchantVO.merchantPublicAccountVO ? scope.row.orderVO.merchantVO.merchantPublicAccountVO.subBank : "" }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="对公账号" min-width="20%">
              <template slot-scope="scope">
                {{ scope.row.orderVO.merchantVO.merchantPublicAccountVO ? scope.row.orderVO.merchantVO.merchantPublicAccountVO.publicAccount : "" }}
              </template>
            </el-table-column>








            <el-table-column align="center" label="状态" min-width="20%">
              <template slot-scope="scope">
                <span style="color: #409EFF">{{ scope.row.isSettlementStr }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="申请时间" min-width="20%">
              <template slot-scope="scope">
                {{ parseDate(scope.row.createDate ? scope.row.createDate : "") }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="20%">
              <template slot-scope="scope">
                 <span style="font-size:0.9rem;color:#25AD7F;cursor: pointer;margin-right:10px;"
                       @click="detailShow(scope.row)">详情</span>
                <span v-if="scope.row.isSettlement==0" style="font-size:0.9rem;color:#25AD7F;cursor: pointer;"
                      @click="updateIsSettlement(scope.row.id)">结算</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%;float: right;margin-top: 10px;text-align: right;">
            <el-pagination
                :current-page="selectForm.pageIndex"
                :page-size="selectForm.pageSize"
                :total="selectForm.total"
                layout="total,prev, pager, next"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- 详情 -->
    <el-dialog :before-close="detailCancel" :visible.sync="detailDialog" title="结算详情" width="40%">
      <div style="width: 100%;float: left">
        <div
            v-if="detailInfo"
            style="width: 100%;float: left;border-bottom: 1px solid #80808054;padding-bottom: 15px;margin-bottom: 20px;">
          <el-descriptions :column=2 title="结算单">

            <el-descriptions-item label="订单号">{{ detailInfo.orderVO ? detailInfo.orderVO.orderNo : "" }}
            </el-descriptions-item>

            <el-descriptions-item label="产品名称">
              {{ detailInfo.orderVO.productVO ? detailInfo.orderVO.productVO.name : "" }}
            </el-descriptions-item>

            <el-descriptions-item label="产品金额">{{ detailInfo.orderVO ? detailInfo.orderVO.productMoney : "" }}元
            </el-descriptions-item>
            <el-descriptions-item label="支付金额">{{ detailInfo.orderVO ? detailInfo.orderVO.payMoney : "" }}元
            </el-descriptions-item>
            <el-descriptions-item label="提现手续费">0.6%
            </el-descriptions-item>
            <el-descriptions-item label="提现金额">
              {{ detailInfo.orderVO ? mexFeixd(detailInfo.orderVO.payMoney * (1 - 0.0006)) : "" }}元
            </el-descriptions-item>
            <el-descriptions-item label="状态">{{ detailInfo.isSettlementStr }}
            </el-descriptions-item>
            <el-descriptions-item label="申请时间">{{ parseDate(detailInfo.createDate ? detailInfo.createDate : "") }}
            </el-descriptions-item>

          </el-descriptions>
          <el-descriptions v-if="detailInfo.orderVO.merchantVO" :column=2 title="商户">
            <el-descriptions-item label="商户名称">
              {{ detailInfo.orderVO.merchantVO.merchantDetailVO ? detailInfo.orderVO.merchantVO.merchantDetailVO.companyName : "" }}
            </el-descriptions-item>

            <el-descriptions-item label="账户名称">
              {{ detailInfo.orderVO.merchantVO.merchantPublicAccountVO ? detailInfo.orderVO.merchantVO.merchantPublicAccountVO.name : "" }}
            </el-descriptions-item>

            <el-descriptions-item label="开户银行">
              {{ detailInfo.orderVO.merchantVO.merchantPublicAccountVO ? detailInfo.orderVO.merchantVO.merchantPublicAccountVO.bank : "" }}
            </el-descriptions-item>

            <el-descriptions-item label="开户支行">
              {{ detailInfo.orderVO.merchantVO.merchantPublicAccountVO ? detailInfo.orderVO.merchantVO.merchantPublicAccountVO.subBank : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="对公账号">
              {{ detailInfo.orderVO.merchantVO.merchantPublicAccountVO ? detailInfo.orderVO.merchantVO.merchantPublicAccountVO.publicAccount : "" }}
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions  :column=2 title="结算人">
            <el-descriptions-item label="结算人">
              {{ detailInfo.settlementUserVO ? detailInfo.settlementUserVO.name : "" }}
            </el-descriptions-item>

            <el-descriptions-item label="结算时间">
              {{ detailInfo.settlementDateStr ? detailInfo.settlementDateStr : "" }}
            </el-descriptions-item>

          </el-descriptions>
        </div>

      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-cancel" @click="detailCancel">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>


import {getAlexBoolListApi} from "@/router/api/common/data-api";

import {pageOrderSettlementApi, updateOrderSettlementApi} from "@/router/api/order/order-settlement-api";
import {listAllMerchantApi} from "@/router/api/merchant/merchant-api";
import * as XLSX from "xlsx";

export default {
  name: "OrderSettlementIndex",
  data() {
    return {
      alexBoolList: [],

      merchantList:[],

      // 查询
      tableData: [],
      selectForm: {
        isSettlement:null,
        orderNo:null,
        merchantId:null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      selectTableRow: [],
      tableLoading:false,

      //  详情
      detailDialog: false,
      detailInfo: null,


    };
  },

  mounted() {

    this.load();


  },

  methods: {

    load() {

      getAlexBoolListApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.alexBoolList = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });

      listAllMerchantApi({}, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.merchantList = res.data.resultSetData;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });

      this.pageOrderSettlement();
    },

    // 详情 begin
    detailShow(data) {
      this.detailInfo = data;
      this.detailDialog = true;
    },

    detailCancel() {
      this.detailDialog = false;
      this.detailInfo = null;
    },
    // 详情 end

    // 查询 begin
    selectReset() {
      this.selectForm = {
        name: null,
        isShelf: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      };
      this.pageOrderSettlement(true);
    },

    handleCurrentChange(e) {
      this.selectForm.pageIndex = e;
      this.pageOrderSettlement(true);
    },

    handleSelectionChange(val) {
      this.selectTableRow = val;
    },

    pageOrderSettlement(showMessage) {
      this.tableLoading = true;
      pageOrderSettlementApi(this.selectForm, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              if (showMessage) {
                this.showMessage(res.data.msg, "success");
              }
              this.tableData = res.data.resultSetData.list;
              this.selectForm.pageIndex = res.data.resultSetData.pageNum;
              this.selectForm.pageSize = res.data.resultSetData.pageSize;
              this.selectForm.total = res.data.resultSetData.total;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      }, res => {
        this.tableLoading = false;
      });
    },

    updateIsSettlement(id) {
      updateOrderSettlementApi({
        id: id,
        isSettlement: "1"
      }, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              this.showMessage(res.data.msg, "success");
              this.pageOrderSettlement();
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      });
    },

    exportTable() {
      if (!this.selectTableRow || this.selectTableRow.length == 0) {
        this.showMessage("请勾选需要导出的数据", "warning");
        return false;
      }

      const data = [
        [
          "订单号",
          "商户",
          "产品名称",
          "产品金额",
          "支付金额",
          "提现手续费",
          "提现金额",
          "账户名称",
          "开户银行",
          "开户支行",
          "对公账号",
          "状态",
          "申请时间",
          "结算人",
          "结算时间",
        ]
      ]
      for (let i = 0; i < this.selectTableRow.length; i++) {
        let row = this.selectTableRow[i];
        if (row) {
          let cell0 = row.orderVO ? row.orderVO.orderNo : ""
          let cell1 =  row.orderVO && row.orderVO.merchantVO && row.orderVO.merchantVO.merchantDetailVO ? row.orderVO.merchantVO.merchantDetailVO.companyName : ""
          let cell2 = row.orderVO.productVO ? row.orderVO.productVO.name : ""
          let cell3 =  row.orderVO ? row.orderVO.productMoney : ""
          let cell4 = row.orderVO ? row.orderVO.payMoney : ""
          let cell5 = "0.6%"
          let cell6 = row.orderVO ? this.mexFeixd(row.orderVO.payMoney * (1 - 0.0006)) : ""
          let cell7 = row.orderVO.merchantVO.merchantPublicAccountVO ? row.orderVO.merchantVO.merchantPublicAccountVO.name : ""
          let cell8 =row.orderVO.merchantVO.merchantPublicAccountVO ? row.orderVO.merchantVO.merchantPublicAccountVO.bank : ""
          let cell9 = row.orderVO.merchantVO.merchantPublicAccountVO ? row.orderVO.merchantVO.merchantPublicAccountVO.subBank : ""
          let cell10 = row.orderVO.merchantVO.merchantPublicAccountVO ? row.orderVO.merchantVO.merchantPublicAccountVO.publicAccount : ""
          let cell11 = row.isSettlementStr ? row.isSettlementStr : "";
          let cell12 = this.parseDate(row.createDate ? row.createDate : "")
          let cell13 = row.settlementUserVO ? row.settlementUserVO.name : "";
          let cell14 = row.settlementDateStr ? row.settlementDateStr : "";
          data.push([cell0, cell1, cell2, cell3, cell4, cell5, cell6, cell7, cell8, cell9, cell10, cell11, cell12, cell13, cell14]);
        }
      }
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, {bookType: "xlsx", type: "array"});

      // 使用blob和FileReader创建一个Blob URL
      const dataBlob = new Blob([excelBuffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
      const blobUrl = window.URL.createObjectURL(dataBlob);

      // 使用saveAs下载文件
      saveAs(dataBlob, "提现结算-" + new Date().toLocaleString() + ".xlsx");

      // 清理
      window.URL.revokeObjectURL(blobUrl);
    },

    // 修改 end

    // 工具

    mexFeixd(value) {
      if (value) {
        return value.toFixed(2);
      }
      return value;
    },

    parseDate(date) {
      if (date) {
        return new Date(date).toLocaleString();
      }
      return "";
    }
  }


}
;

</script>


<style scoped>

/deep/ .el-card__body, .el-main {
  float: left;
  width: 100%;
}

/*  通用 */
.dialog-footer {
  width: 100%;
  float: left;
  text-align: left;
}

.dialog-footer-submit {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-submit:hover {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel:hover {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

/* 树形菜单 */

/deep/ .el-tree-node__content {
  height: 35px;
  line-height: 35px;
}

/* 表格 */

/deep/ .el-table th.el-table__cell {
  background-color: #F8F8F8;
}

/deep/ .el-table th.el-table__cell > .cell {
  color: #554 !important;
  font-weight: 600;
  font-size: 1.05rem;
}


/* 模态框 */

/deep/ .el-dialog__title {
  font-weight: 600;
}

/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid darkgray;
}

/deep/ .el-dialog__body {
  width: 100%;
  float: left;
  background-color: white;
}

/deep/ .el-upload-dragger {
  height: auto;
}

/deep/ .el-form-item__content {
  text-align: left;
}


/* 纯数字 */
/deep/ .numberInput input::-webkit-outer-spin-button,
/deep/ .numberInput input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ .numberInput input[type="number"] {
  -moz-appearance: textfield;
}

</style>
